// // ====================================
// //    CHECK SMART ID ALREADY IN CART
// // ====================================
var buttonNextPesonalize = $('#maf_SmartMedicalID_addToCart_noPlan');

function isCtaOutOfStock() {
  return buttonNextPesonalize.is(":disabled") ||
         buttonNextPesonalize.attr("aria-disabled") === "true" ||
         buttonNextPesonalize.hasClass("out-of-stock-button");
}

function treatButtonAlreadyInCart(){
    if (isCtaOutOfStock()) return; // don't override OOS
    buttonNextPesonalize.addClass(['disabled', 'btn-secondary']).text('Already in Cart');
}

function removeButtonAlreadyInCart(){
    if (isCtaOutOfStock()) return; // don't override OOS
    buttonNextPesonalize.removeClass(['disabled', 'btn-secondary']).text('ADD TO CART');
}

function itemInCart(numItems, itemsIDs){
    setTimeout(function(){ 
        var pdpProductID = $('.product-id')[0].textContent;
        $.each(itemsIDs, function(index, element) {
            if(pdpProductID == element.id){                
                treatButtonAlreadyInCart();
                return false;
            }else{
                removeButtonAlreadyInCart();
            }
        });
    }, 333);

}

function findIfItemInCart(){
    var url = "/on/demandware.store/Sites-medicalert-Site/en_US/Cart-Get";
    $.ajax({
        url:      url,
        type:     'GET',
        dataType: 'json',
        success:  function(data) {
            itemInCart(data.numItems,data.items);
        }
    });
}

findIfItemInCart();
